import { asyncRoutes, constantRouterMap } from "@/router";

const hasPermission = (roles, route) => {
	if (route?.meta?.roles) {
		return roles.some((role) => route.meta.roles.includes(role));
	} else {
		return true;
	}
};

export const filterAsyncRoutes = (routes, roles) => {
	const res = [];

	routes.forEach((route) => {
		const tmp = { ...route };

		if (hasPermission(roles, tmp)) {
			if (tmp.children) {
				tmp.children = filterAsyncRoutes(tmp.children, roles);
			}
			res.push(tmp);
		}
	});

	return res;
};

const permission = {
	state: {
		routes: [],
		addRoutes: [],
	},
	mutations: {
		SET_ROUTES: (state, routes) => {
			state.addRoutes = routes;
			state.routes = constantRouterMap.concat(routes);
		},
	},
	actions: {
		GenerateRoutes({ commit }, data) {
			return new Promise((resolve) => {
				const { permissions } = data;

				let accessedRoutes;

				if (permissions.includes("admin")) {
					accessedRoutes = asyncRoutes;
				} else {
					accessedRoutes = filterAsyncRoutes(asyncRoutes, permissions);
				}

				commit("SET_ROUTES", accessedRoutes);
				resolve(accessedRoutes);
			});
		},
	},
};

export default permission;
